import { ControllerHelper, MediaDownloadDto, PlayListNodeDownloadDto, PlaylistDownloadDto, PlaylistUploadDto, PostController, PostDownloadDto } from 'collaboration-service';
import SafeHTML from 'components/SafeHTML/SafeHTML';
import { Icon, LoaderInline } from 'imaginarity-react-ui';
import _ from 'lodash';
import * as React from 'react';
import { ApplicationState, useAppSelector } from 'services/ApplicationState/ApplicationState';
import { convertMinutesToDaysHoursMinutes, shallowCompare } from 'services/Helpers';
import { sanitizedNothingAllowed, sanitizedNothingAllowedAttributes } from 'services/Helpers/SanitizedHelper';
import { getTranslated } from 'services/Helpers/TranslationHelpers';
import { useImgI18N } from 'services/ImgI18N';
import PlaylistEditContentImplementedElement, { playlistContentToIcon } from './Edit/PlaylistEditContentImplementedElement';
import { PlaylistSC as T } from "./PlaylistSC";

const mapper = (state: ApplicationState) => ({ contentLanguage: state.contentLanguage });

interface PlaylistPreviewProps {
    nodes: PlayListNodeDownloadDto[];
    posts: PostDownloadDto[] | undefined;
    id: string;
}

const PlaylistPreview = (p: PlaylistPreviewProps) => {
    const { nodes, posts, id } = p;
    const { contentLanguage } = useAppSelector(mapper, shallowCompare);
    const { t } = useImgI18N("playlist");
    const [data, setData] = React.useState<PlaylistUploadDto>({
        categories: [],
        headlines: [],
        descriptions: [],
        group_id: "",
        media: {} as MediaDownloadDto,
        tags: [],
        languageTags: [],
        stickyHours: 0,
        trainerDocumentsReferenceIds: []
    });

    React.useEffect(() => {
        const load = async () => {
            if (id) {
                const playlist = await ControllerHelper.singleCall({ id }, PostController.GetSinglePost) as any as PlaylistDownloadDto;
                setData(playlist);
            }
        }
        load();
    }, [id]);

    return (
        <T.PreviewContainer>
            {nodes.length > 0 ?
                <T.PreviewContainerGrid>
                    {_.map(nodes, (node, i) => {
                        const estDuration = node.durationInMinutes ? convertMinutesToDaysHoursMinutes(node.durationInMinutes, t, true) : undefined;
                        return (
                            <React.Fragment key={i}>
                                <div style={{ fontWeight: "bolder", paddingLeft: 10 }}><SafeHTML html={getTranslated(node.headlines, contentLanguage)?.text ?? ""} allowedTags={sanitizedNothingAllowed} allowedAttributes={sanitizedNothingAllowedAttributes} /></div>
                                <div><Icon name="clock" style={{ float: "left", marginRight: 10 }} marginTop={1} />{estDuration}</div>
                                <T.PreviewContainerItemsRow style={{ gridTemplateColumns: "1fr" }}>
                                    {_.map(node.referenceIds, (refId, j) => {
                                        const pc = _.find(posts, c => c.id === refId);
                                        const content = _.find(data.contents, c => c.referenceId === refId);
                                        if (pc && content) {
                                            return <PlaylistEditContentImplementedElement
                                                content={content}
                                                numberOfUsed={0}
                                                post={pc}
                                                sortByType
                                                toggleHidden={() => undefined}
                                                key={pc.id}
                                                showAsList={true}
                                                noLink={true}
                                                noInfo={true}
                                            />
                                        }
                                        else {
                                            return (
                                                <React.Fragment key={j}>
                                                    <T.PreviewContainerItemType />
                                                    <T.PreviewContainerItemLoading shown={j === 0}>
                                                        <LoaderInline active infoText={t("loading data")} />
                                                    </T.PreviewContainerItemLoading>
                                                </React.Fragment>
                                            );
                                        }
                                    })}

                                </T.PreviewContainerItemsRow>
                            </React.Fragment>
                        );
                    })}
                </T.PreviewContainerGrid>
                :
                <T.PreviewContainerAAOGrid>
                    {_.map(data.contents, (p, i) => {
                        const pc = _.find(posts, c => c.id === p.referenceId);
                        if (pc) {
                            const icon = playlistContentToIcon(pc);
                            const title = getTranslated(pc.headlines, contentLanguage)?.text ?? "";
                            const sanitizedTitle = title.replace(/<\/?p>/g, '');
                            const pcType = pc?.type === 'FileEntry' ? 'CMS' : pc?.type;
                            return (
                                <React.Fragment key={i}>
                                    <T.PreviewContainerItemsRowAAO>
                                        <T.PreviewContainerItemTypeAAO>
                                            <Icon name={icon ?? "empty"} style={{ float: "left", marginRight: 10 }} marginTop={1} />
                                            {pcType}
                                        </T.PreviewContainerItemTypeAAO>
                                        <div>
                                            {sanitizedTitle}
                                        </div>
                                    </T.PreviewContainerItemsRowAAO>
                                </React.Fragment>
                            );
                        }
                    })}
                </T.PreviewContainerAAOGrid>
            }
        </T.PreviewContainer>
    );
}
export default PlaylistPreview;